import PropTypes from "prop-types";
import { createContext, useEffect, useState } from "react";
import { isBoolean, isUndefined } from "underscore";

// Allow clients to have cleaner imports
export { AccordionContent } from "@javascript/reactComponents/lds/accordion/AccordionContent";
export { AccordionTrigger } from "@javascript/reactComponents/lds/accordion/AccordionTrigger";

export const AccordionContext = createContext({
  open: false,
  toggle: () => {},
});

export default function Accordion({
  id,
  className,
  children,
  initialOpen,
  open,
  style,
}) {
  if (isBoolean(open) && isBoolean(initialOpen)) {
    console.warn(
      "[LDS Accordion] A controlled accordion should not also have `initialOpen` provided."
    );
  }

  const [controlledOpen, setControlledOpen] = useState(!!(initialOpen || open));

  useEffect(() => {
    if (isBoolean(open)) {
      setControlledOpen(open);
    }
  }, [open]);

  const handleToggle = () => {
    if (isUndefined(open)) {
      setControlledOpen(!controlledOpen);
    }
  };

  const classNames = ["lds-accordion-container", className];

  return (
    <AccordionContext.Provider
      value={{
        open: controlledOpen,
        toggle: handleToggle,
      }}
    >
      <div className={classNames.join(" ")} id={id} style={style}>
        {children}
      </div>
    </AccordionContext.Provider>
  );
}

Accordion.propTypes = {
  className: PropTypes.string,
  initialOpen: PropTypes.bool,
  open: PropTypes.bool,
  style: PropTypes.object,
};
